module.exports = __webpack_public_path__ + "img/FilSensorBlack.144b562c.svg";